import React from 'react';

function About() {
  return (
    <div>
      <h1>About</h1>
      <h4>
        Hello, this is a small web app I made to search for users on Github and
        view their profiles.
      </h4>
      <p>
        It has routing using React Router and styling applied using @emotion.
      </p>
    </div>
  );
}

export default About;
